/* eslint-disable react/jsx-props-no-spreading */
import { useRouteMatcher, useRoutes, useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import { useCallback } from 'react';
// import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAuthLogout } from '../../hooks/useAuth';

// import { useAuthLogout } from '../../hooks/useAuth';

import BasicButton from '../buttons/BasicButton';

import styles from '../../styles/menus/account-menu.module.css';

import subscriptionIcon from '../../assets/img/account/Abonnements.svg';
import activitiesIcon from '../../assets/img/account/Activites.svg';
import accountIcon from '../../assets/img/account/Maison.svg';
import profileIcon from '../../assets/img/account/Profil.svg';

interface AccountMenuProps {
    className?: string | null;
}

function AccountMenu({ className = null }: AccountMenuProps) {
    const url = useUrlGenerator();

    const routes = useRoutes();
    const routeMatcher = useRouteMatcher();

    const items = [
        {
            id: 'account',
            route: 'account',
            label: <FormattedMessage defaultMessage="Compte" description="Filter label" />,
            icon: accountIcon,
        },
        {
            id: 'profile',
            route: 'account.profile',
            label: <FormattedMessage defaultMessage="Profil" description="Filter label" />,
            icon: profileIcon,
        },
        {
            id: 'subscriptions',
            route: 'account.subscriptions',
            label: <FormattedMessage defaultMessage="Abonnements" description="Filter label" />,
            icon: subscriptionIcon,
        },
        {
            id: 'timeline',
            route: 'account.timeline',
            label: <FormattedMessage defaultMessage="Activités" description="Filter label" />,
            icon: activitiesIcon,
        },
    ];

    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.inner}>
                {items.map(
                    ({
                        id,
                        route = null,
                        label,
                        icon = null,
                        // className: buttonClassName,
                        ...props
                    }) => {
                        const [match = false] = route !== null ? routeMatcher(routes[route]) : [];
                        return (
                            <BasicButton
                                key={id || route}
                                href={route !== null ? url(route) : null}
                                className={classNames([
                                    styles.button,
                                    [styles[id]],
                                    {
                                        [styles.active]: match,
                                    },
                                    // buttonClassName,
                                ])}
                                {...props}
                            >
                                {icon !== null ? <img src={icon} className={styles.icon} /> : null}
                                <span className={styles.label}>{label}</span>
                            </BasicButton>
                        );
                    },
                )}
            </div>
        </div>
    );
}

export default AccountMenu;
